export default __webpack_public_path__ + "static/media/Bg_2023_mobile.261765b4.png";